import React from 'react';
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import ApptReqPreview from './ApptReqPreview';
import './style.css';

function ApptReqPreviewModal(props) {
  const {
    onClose,
    appointment,
    classes: {
      visitInfo,
      confirmationFields,
      confirmationCardAppointmentSection,
      confirmationCardAppointmentSectionTitle,
      confirmationCardAppointmentSectionText,
      notes,
      previewImg,
      modalContent,
      modal,
      marginZero,
    },
  } = props;


  return (
    <Dialog
      fullWidth
      open={!!appointment}
      onClose={onClose}
      classes={{ paper: modal }}
      maxWidth={'xl'}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>Appointment Request</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      
      <DialogContent classes={{ root: modalContent }}>
    <div className="marginZero">
     
        <ApptReqPreview
        
          appointment={appointment}
        />
     </div>
      </DialogContent>

    </Dialog>
  
  );
}

const styles = () => ({
  visitInfo: {
    marginRight: '25px',
    '@media only screen and (max-width: 1024px)': {
      marginRight: '0',
      marginBottom: '25px',
    },
  },
  confirmationCard: {
    backgroundColor: '#EBF5FF',
    padding: '30px',
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
    margin: '0 20px',
  },
  confirmationFields: {
    margin: '0 20px',
  },
  confirmationCardAppointment: {
    marginTop: '24px',
  },
  confirmationCardAppointmentSection: {
    paddingBottom: '34px',
  },
  confirmationCardAppointmentSectionTitle: {
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    color: '#606A74',
    fontWeight: 'normal',
  },
  confirmationCardAppointmentSectionText: {
    color: '#1C2B39',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '19px',
  },
  notes: {
    width: '100%',
  },
  attachmentsBtn: {
    paddingBottom: '5px',
  },
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  previewImg: {
    maxWidth: 300,
    maxHeight: 300,
  },

});

export default withStyles(styles)(ApptReqPreviewModal);
